/**
 * Created by sagardesai on 13/07/18.
 */

//join broadcast
export const JOIN_BROADCAST_REQUEST = "JOIN_BROADCAST_REQUEST";
export const JOIN_BROADCAST_RECEIVE = "JOIN_BROADCAST_RECEIVE";
export const JOIN_BROADCAST_FAILURE = "JOIN_BROADCAST_FAILURE";
export const RESET_JOIN_BROADCAST= "RESET_JOIN_BROADCAST";

//join broadcast
export const JOIN_PRIVATE_BROADCAST_REQUEST = "JOIN_PRIVATE_BROADCAST_REQUEST";
export const JOIN_PRIVATE_BROADCAST_RECEIVE = "JOIN_PRIVATE_BROADCAST_RECEIVE";
export const JOIN_PRIVATE_BROADCAST_FAILURE = "JOIN_PRIVATE_BROADCAST_FAILURE";
export const RESET_JOIN_PRIVATE_BROADCAST= "RESET_JOIN_PRIVATE_BROADCAST";